module.exports = __webpack_public_path__ + "img/story022@2x.a69d04bc.webp";